/**
 * Utility functions for job status conversion
 */
import { JobStatus } from '../types'

/**
 * Convert database status format to UI format
 */
export const dbFormatToStatus = (status: string | null | undefined): JobStatus => {
  if (!status) return 'Bookmarked'
  // Handle multi-word statuses (with spaces or underscores)
  const separator = status.includes('_') ? '_' : ' '
  const parts = status.split(separator)
  return parts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(' ') as JobStatus
}

/**
 * Convert UI status to database format
 */
export const statusToDbFormat = (status: JobStatus): string => {
  const statusMap: Record<JobStatus, string> = {
    'Bookmarked': 'bookmarked',
    'Applying': 'applying',
    'Applied': 'applied',
    'Interviewing': 'interviewing',
    'Negotiating': 'negotiating',
    'Accepted': 'accepted',
    'I Withdrew': 'i withdrew',
    'Not Selected': 'not selected',
    'No Response': 'no response',
    'Archived': 'archived',
  }
  return statusMap[status] || status.toLowerCase()
}


